import "../../preload-page.ts";
import "../../../src-routes/data/_sheep-market.scss";
import "../../../src-routes/index";
import S from "s-js";
import {SheepChart} from "../../_components/sheep-chart/SheepChart"
function mountSurplus(selector: string, domObj: any) {
        let root = (document.querySelector(selector) as HTMLElement);
        while (root.firstChild) {
            root.removeChild(root.firstChild);
        }
        
        if(domObj instanceof Element){         
            let dom = domObj;
            dom.id = selector.replace("#","");
            (root.parentNode as HTMLElement).replaceChild(dom,root);
        }else{   
            let dom = domObj.dom;
            dom.id = selector.replace("#","");
            (root.parentNode as HTMLElement).replaceChild(dom,root);
            domObj.onMount();
        }
        }
S.root(()=>{
mountSurplus("#INmZhMTk0YWNmMzViM2NlZDdlODQzNjAzM2RmNDAxYzQx", SheepChart())
});